import React from 'react';

import cx from 'classnames';

import convertMjmlStyleProps from './convertMjmlStyleProps';

import styles from './styles.scss';

export default function MjmlText({
  className,
  style,
  children,
  ...otherProps
}: any) {
  return (
    <span
      className={cx(styles.MjmlText, className)}
      style={{ ...style, ...convertMjmlStyleProps(otherProps) }}
    >
      {children}
    </span>
  );
}
